import React from 'react';
import ConversorUniversal from './components/ConversorUniversal';

function App() {
  return <ConversorUniversal />;
}

export default App;
